const ACIMA_IFRAME_URL = process.env.ACIMA_IFRAME_URL || '';
const ACIMA_MERCHANT_ID = process.env.ACIMA_MERCHANT_ID || '';
const ACIMA_SDK_URL = process.env.ACIMA_SDK_URL || '';

export {
  ACIMA_IFRAME_URL,
  ACIMA_MERCHANT_ID,
  ACIMA_SDK_URL,
};